<template>
    <div>
        <div class="basic_wrap">
            <!-- <img src="@/assets/images/bg_mobile.png" class="bgImg" alt=""> -->
            <!-- 顶部导航栏 -->
            <header class="page-header">
                <!-- 左上角WB小标 -->
                <div class="header-logo" @click="resetFun">
                    <svg fill="#fff">
                        <path
                            d="M36.877 9.965V8.042l-2.573-1.393V4.638l-1.319-.627C29.239 2.222 25.093 1.028 20.313.392l-.312-.043-.312.043c-4.781.635-8.927 1.829-12.675 3.617l-1.319.628v2.011L3.123 8.041v1.925L.328 11.464l.221 1.597C1.29 18.42 3.242 23.27 6.354 27.48c3.144 4.253 7.387 7.733 12.613 10.344l1.035.517 1.035-.517c5.225-2.611 9.469-6.091 12.613-10.344 3.111-4.208 5.063-9.059 5.805-14.419l.221-1.597zm.273 2.779c-.261 1.787-1.101 7.627-5.373 13.359-4.344 5.901-10.056 8.765-11.779 9.645-1.723-.881-7.435-3.744-11.779-9.645C3.947 20.37 3.107 14.53 2.846 12.744l2.595-1.392V9.421l2.571-1.393V6.101C11.57 4.403 15.489 3.289 20 2.69c4.509.599 8.429 1.717 11.987 3.411V8.03l2.573 1.393v1.931l2.595 1.392z">
                        </path>
                        <path
                            d="M16.153 7.329l.12 15.697-.109.064c-1.661-4.201-2.653-9.441-2.966-14.699a20.571 20.571 0 00-2.569 1.383c.357 4.769 1.175 8.941 2.637 12.901l-.829.48C10.24 20.08 8.805 16.34 7.821 11.902a22.857 22.857 0 00-2.009 2.059c1.288 5.327 3.315 9.36 6.277 12.645l2.283-1.365a26.286 26.286 0 004.417 6.469V6.865a17.12 17.12 0 00-2.635.465zM30.853 15.421c.931-1.031 1.129-1.779 1.129-2.687 0-1.285-1.059-2.427-2.603-3.407-.931-.593-2.357-1.312-4.437-1.891a17.486 17.486 0 00-3.729-.573v24.848c5.221-2.688 11.432-10.056 11.464-13.805.009-1.145-.595-1.895-1.825-2.485m-7.071-5.587c1.287 0 5.447 1.315 5.447 2.976 0 .599-.528 1.456-2.173 2.321l-3.272 1.755zm3.243 13.781c-.736.847-1.939 2.141-3.243 3.147v-7.131s4.721-2.657 4.895-2.769c1.413.357 1.341 1.397 1.341 1.505-.001 1.309-1.339 3.336-2.995 5.249">
                        </path>
                    </svg>
                </div>
                <!-- 右侧汉堡菜单 -->
                <div class="menu-btn" @click.stop="menuShow = true">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </header>

            <!-- 主体内容区域 -->
            <main class="content-wrap">
                <!-- 中心WB大Logo -->
                <div class="main-wb-logo">
                    <img src="@/assets/images/logos.png" alt="">
                </div>

                <!-- 账号列表 -->
                <div class="account-list">
                    <div class="account-item" v-for="item in accountData" :key="item.username">
                        <p class="follow-text">{{ $t('Follow') }}</p>
                        <h2 class="username">{{ item.username }}</h2>
                        <div class="social-icons">
                            <!-- Instagram -->
                            <div class="icons" @click.stop="toUrl('https://www.instagram.com/WarnerBrosHorror')">
                                <svg class="icon" viewBox="0 0 24 24" fill="#1E249E">
                                    <path
                                        d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                                </svg>
                            </div>
                            <!-- TikTok -->
                            <div class="icons" @click.stop="toUrl('https://www.tiktok.com/@warnerbroscomedy')">
                                <svg class="icon" viewBox="0 0 24 24" fill="#1E249E">
                                    <path
                                        d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.77 1.66-1.44 3.98-1.93 6.15-1.8.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.32 1.31 2.43 2.5 2.96.9.22 1.87.31 2.8.01.98-.33 1.87-.93 2.49-1.77.42-.55.72-1.17.87-1.84.16-.69.16-1.41.01-2.1-.05-.27-.15-.53-.28-.77.4-.03.8-.04 1.2-.04z" />
                                </svg>
                            </div>
                            <!-- Facebook -->
                             <a @click.stop="toUrl('https://www.facebook.com/WarnerBrosHorror')">
                                 <svg class="icon" viewBox="0 0 24 24" fill="#fff" >
                                    <path
                                        d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                                </svg>
                             </a>
                           
                        </div>
                    </div>
                </div>

                <!-- 立即登录按钮 -->
                <button class="login-btn" @click.stop="showLogin = true">{{ $t('login.signInBtn') }}</button>

                <!-- 分割线 -->
                <div class="divider-line"></div>

                <!-- 最新影视项目区域 -->
                <section class="movie-section" v-if="newsList.length > 0">
                    <h2 class="section-title">{{ $t('最新影视项目 | 即时上新') }}</h2>
                    <div class="movie-scroll-wrap">
                        <div class="movie-list">
                            <a class="movie-item" v-for="film in newsList" :key="film.title"  @click.stop="showLogin = true">
                                <div class="poster">
                                    <!-- 替换为你的海报图片地址 -->
                                    <img :src="film.img" alt="" />
                                </div>
                                <div class="film-name">{{ film.title }}</div>
                            </a>
                        </div>
                    </div>
                </section>
                <section class="movie-section" v-if="filmList.length > 0" style="margin-top: 30px;">
                    <h2 class="section-title">{{ $t('热门影视项目 | 人气之选') }}</h2>
                    <div class="movie-scroll-wrap">
                        <div class="movie-list">
                            <div class="movie-item" v-for="film in filmList" :key="film.title"  @click.stop="showLogin = true">
                                <div class="poster">
                                    <!-- 替换为你的海报图片地址 -->
                                    <img :src="film.img" alt="" />
                                </div>
                                <div class="film-name">{{ film.title }}</div>
                            </div>
                        </div>
                    </div>
                </section>

            </main>
        </div>
        <div class="gfNxcW">
            <div class="ezeceZ">{{ $t('FollowUs') }}</div>
            <nav class=" kHvagc">
                <a href="https://www.facebook.com/warnerbrosent/" target="_blank" aria-label="Facebook - WarnerBros.com"
                    tabindex="0">
                    <svg class="facebook-icon" viewBox="0 0 32 32" focusable="false" aria-label="Facebook">
                        <path
                            d="M31.997 15.999c0-8.836-7.163-15.999-15.999-15.999s-15.999 7.163-15.999 15.999c0 7.985 5.851 14.604 13.499 15.804v-11.18h-4.062v-4.625h4.062v-3.525c0-4.010 2.389-6.225 6.043-6.225 1.75 0 3.581 0.312 3.581 0.312v3.937h-2.017c-1.987 0-2.607 1.233-2.607 2.498v3.001h4.437l-0.709 4.625h-3.728v11.18c7.649-1.2 13.499-7.819 13.499-15.804z">
                        </path>
                    </svg>​
                </a>
                <a href="https://twitter.com/Warnerbros/" target="_blank" aria-label="Twitter - WarnerBros.com"
                    tabindex="0">
                    <svg class="twitter-icon" viewBox="0 0 32 32" focusable="false" aria-label="Twitter">
                        <path
                            d="M 17.855469 12.695312 L 29.023438 0 L 26.375 0 L 16.679688 11.023438 L 8.933594 0 L 0 0 L 11.710938 16.671875 L 0 29.984375 L 2.648438 29.984375 L 12.886719 18.34375 L 21.066406 29.984375 L 30 29.984375 L 17.851562 12.695312 Z M 14.230469 16.816406 L 13.042969 15.15625 L 3.601562 1.949219 L 7.664062 1.949219 L 15.285156 12.609375 L 16.472656 14.269531 L 26.378906 28.125 L 22.3125 28.125 Z M 14.230469 16.816406 ">
                        </path>
                    </svg>​
                </a>
                <a href="https://www.pinterest.com/warnerbrosent/" target="_blank"
                    aria-label="Pinterest - WarnerBros.com" tabindex="0">
                    <svg class="pinterest-icon" viewBox="0 0 32 32" focusable="false" aria-label="Pinterest">
                        <path
                            d="M16 2.138c-7.656 0-13.863 6.206-13.863 13.863 0 5.875 3.656 10.887 8.813 12.906-0.119-1.094-0.231-2.781 0.050-3.975 0.25-1.081 1.625-6.887 1.625-6.887s-0.412-0.831-0.412-2.056c0-1.925 1.119-3.369 2.506-3.369 1.181 0 1.756 0.887 1.756 1.95 0 1.188-0.756 2.969-1.15 4.613-0.331 1.381 0.688 2.506 2.050 2.506 2.462 0 4.356-2.6 4.356-6.35 0-3.319-2.387-5.638-5.787-5.638-3.944 0-6.256 2.956-6.256 6.019 0 1.194 0.456 2.469 1.031 3.163 0.113 0.137 0.131 0.256 0.094 0.4-0.106 0.438-0.338 1.381-0.387 1.575-0.063 0.256-0.2 0.306-0.463 0.188-1.731-0.806-2.813-3.337-2.813-5.369 0-4.375 3.175-8.387 9.156-8.387 4.806 0 8.544 3.425 8.544 8.006 0 4.775-3.012 8.625-7.194 8.625-1.406 0-2.725-0.731-3.175-1.594 0 0-0.694 2.644-0.863 3.294-0.313 1.206-1.156 2.712-1.725 3.631 1.3 0.4 2.675 0.619 4.106 0.619 7.656 0 13.863-6.206 13.863-13.863 0-7.662-6.206-13.869-13.863-13.869z">
                        </path>
                    </svg>
                    ​</a>
                <a href="https://www.instagram.com/warnerbrosentertainment/" target="_blank"
                    aria-label="Instagram - WarnerBros.com" tabindex="0">
                    <svg class="instagram-icon" viewBox="0 0 32 32" focusable="false" aria-label="Instagram">
                        <path
                            d="M16 2.881c4.275 0 4.781 0.019 6.462 0.094 1.563 0.069 2.406 0.331 2.969 0.55 0.744 0.288 1.281 0.638 1.837 1.194 0.563 0.563 0.906 1.094 1.2 1.838 0.219 0.563 0.481 1.412 0.55 2.969 0.075 1.688 0.094 2.194 0.094 6.463s-0.019 4.781-0.094 6.463c-0.069 1.563-0.331 2.406-0.55 2.969-0.288 0.744-0.637 1.281-1.194 1.837-0.563 0.563-1.094 0.906-1.837 1.2-0.563 0.219-1.413 0.481-2.969 0.55-1.688 0.075-2.194 0.094-6.463 0.094s-4.781-0.019-6.463-0.094c-1.563-0.069-2.406-0.331-2.969-0.55-0.744-0.288-1.281-0.637-1.838-1.194-0.563-0.563-0.906-1.094-1.2-1.837-0.219-0.563-0.481-1.413-0.55-2.969-0.075-1.688-0.094-2.194-0.094-6.463s0.019-4.781 0.094-6.463c0.069-1.563 0.331-2.406 0.55-2.969 0.288-0.744 0.638-1.281 1.194-1.838 0.563-0.563 1.094-0.906 1.838-1.2 0.563-0.219 1.412-0.481 2.969-0.55 1.681-0.075 2.188-0.094 6.463-0.094zM16 0c-4.344 0-4.887 0.019-6.594 0.094-1.7 0.075-2.869 0.35-3.881 0.744-1.056 0.412-1.95 0.956-2.837 1.85-0.894 0.888-1.438 1.781-1.85 2.831-0.394 1.019-0.669 2.181-0.744 3.881-0.075 1.713-0.094 2.256-0.094 6.6s0.019 4.887 0.094 6.594c0.075 1.7 0.35 2.869 0.744 3.881 0.413 1.056 0.956 1.95 1.85 2.837 0.887 0.887 1.781 1.438 2.831 1.844 1.019 0.394 2.181 0.669 3.881 0.744 1.706 0.075 2.25 0.094 6.594 0.094s4.888-0.019 6.594-0.094c1.7-0.075 2.869-0.35 3.881-0.744 1.050-0.406 1.944-0.956 2.831-1.844s1.438-1.781 1.844-2.831c0.394-1.019 0.669-2.181 0.744-3.881 0.075-1.706 0.094-2.25 0.094-6.594s-0.019-4.887-0.094-6.594c-0.075-1.7-0.35-2.869-0.744-3.881-0.394-1.063-0.938-1.956-1.831-2.844-0.887-0.887-1.781-1.438-2.831-1.844-1.019-0.394-2.181-0.669-3.881-0.744-1.712-0.081-2.256-0.1-6.6-0.1v0z">
                        </path>
                        <path
                            d="M16 7.781c-4.537 0-8.219 3.681-8.219 8.219s3.681 8.219 8.219 8.219 8.219-3.681 8.219-8.219c0-4.537-3.681-8.219-8.219-8.219zM16 21.331c-2.944 0-5.331-2.387-5.331-5.331s2.387-5.331 5.331-5.331c2.944 0 5.331 2.387 5.331 5.331s-2.387 5.331-5.331 5.331z">
                        </path>
                        <path
                            d="M26.462 7.456c0 1.060-0.859 1.919-1.919 1.919s-1.919-0.859-1.919-1.919c0-1.060 0.859-1.919 1.919-1.919s1.919 0.859 1.919 1.919z">
                        </path>
                    </svg>​
                </a>
                <a href="https://www.linkedin.com/company/warner-bros--entertainment/" target="_blank"
                    aria-label="LinkedIn - WarnerBros.com" tabindex="0"><svg class="linkedin-icon" viewBox="0 0 32 32"
                        focusable="false" aria-label="LinkedIn">
                        <path
                            d="M12 12h5.535v2.837h0.079c0.77-1.381 2.655-2.837 5.464-2.837 5.842 0 6.922 3.637 6.922 8.367v9.633h-5.769v-8.54c0-2.037-0.042-4.657-3.001-4.657-3.005 0-3.463 2.218-3.463 4.509v8.688h-5.767v-18z">
                        </path>
                        <path d="M2 12h6v18h-6v-18z"></path>
                        <path d="M8 7c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z"></path>
                    </svg>
                    ​</a>
                <a href="https://www.youtube.com/user/WarnerBrosPictures/" target="_blank"
                    aria-label="YouTube - WarnerBros.com" tabindex="0">
                    <svg class="youtube-icon" viewBox="0 0 32 32" focusable="false" aria-label="Youtube">
                        <path
                            d="M31.681 9.6c0 0-0.313-2.206-1.275-3.175-1.219-1.275-2.581-1.281-3.206-1.356-4.475-0.325-11.194-0.325-11.194-0.325h-0.012c0 0-6.719 0-11.194 0.325-0.625 0.075-1.987 0.081-3.206 1.356-0.963 0.969-1.269 3.175-1.269 3.175s-0.319 2.588-0.319 5.181v2.425c0 2.587 0.319 5.181 0.319 5.181s0.313 2.206 1.269 3.175c1.219 1.275 2.819 1.231 3.531 1.369 2.563 0.244 10.881 0.319 10.881 0.319s6.725-0.012 11.2-0.331c0.625-0.075 1.988-0.081 3.206-1.356 0.962-0.969 1.275-3.175 1.275-3.175s0.319-2.587 0.319-5.181v-2.425c-0.006-2.588-0.325-5.181-0.325-5.181zM12.694 20.15v-8.994l8.644 4.513-8.644 4.481z">
                        </path>
                    </svg>
                    ​</a>
                <a aria-label="Newsletter - WarnerBros.com" tabindex="0" href="/newsletter"><svg class="newsletter-icon"
                        viewBox="0 0 28 28" focusable="false" aria-label="Newsletter">
                        <path
                            d="M28 11.094v12.406c0 1.375-1.125 2.5-2.5 2.5h-23c-1.375 0-2.5-1.125-2.5-2.5v-12.406c0.469 0.516 1 0.969 1.578 1.359 2.594 1.766 5.219 3.531 7.766 5.391 1.313 0.969 2.938 2.156 4.641 2.156h0.031c1.703 0 3.328-1.188 4.641-2.156 2.547-1.844 5.172-3.625 7.781-5.391 0.562-0.391 1.094-0.844 1.563-1.359zM28 6.5c0 1.75-1.297 3.328-2.672 4.281-2.438 1.687-4.891 3.375-7.313 5.078-1.016 0.703-2.734 2.141-4 2.141h-0.031c-1.266 0-2.984-1.437-4-2.141-2.422-1.703-4.875-3.391-7.297-5.078-1.109-0.75-2.688-2.516-2.688-3.938 0-1.531 0.828-2.844 2.5-2.844h23c1.359 0 2.5 1.125 2.5 2.5z">
                        </path>
                    </svg>
                    ​</a>
            </nav>
        </div>
        <!-- <div class="sc-fAjcbJ esyBNo footer-policy">
            <nav aria-label="WB links" class="sc-caSCKo bruzGE"><a href="https://www.wbd.com/">Company</a><a
                    href="/studio/services">WB Services</a><a href="https://wbd.com/newsroom">Press Releases</a><a
                    href="https://careers.wbd.com/" target="_blank">WBD Careers</a><a
                    href="/international">International</a><a href="/help/faq">Help</a>
            </nav>
            <nav aria-label="Policy links" class="sc-gisBJw cpSrcS">
                <a href="https://policies.warnerbros.com/terms/en-us/" target="_blank">Terms of Use</a>
                <a
                    href="https://www.warnermediaprivacy.com/policycenter/b2c/wm/" target="_blank">Privacy Policy</a>
                <a
                    href="/content/sourced-traffic-disclosure">Sourced Traffic Disclosure</a><a
                    href="https://www.warnermediaprivacy.com/policycenter/b2c/wm/" target="_blank">Ad Choices</a>
                <a
                    href="https://policies.warnerbros.com/terms/en-us/#accessibility"
                    target="_blank">Accessibility</a>
                <a data-cookie-preference="true" href="javascript:void(0);"
                    class="ot-sdk-show-settings" style="display: inline;">Cookie Settings</a>
            </nav>
        </div> -->
        <div class="sc-bRBYWo">
            <svg fill="#fff" style="width: 42px;height: 42px;">
                <path
                    d="M36.877 9.965V8.042l-2.573-1.393V4.638l-1.319-.627C29.239 2.222 25.093 1.028 20.313.392l-.312-.043-.312.043c-4.781.635-8.927 1.829-12.675 3.617l-1.319.628v2.011L3.123 8.041v1.925L.328 11.464l.221 1.597C1.29 18.42 3.242 23.27 6.354 27.48c3.144 4.253 7.387 7.733 12.613 10.344l1.035.517 1.035-.517c5.225-2.611 9.469-6.091 12.613-10.344 3.111-4.208 5.063-9.059 5.805-14.419l.221-1.597zm.273 2.779c-.261 1.787-1.101 7.627-5.373 13.359-4.344 5.901-10.056 8.765-11.779 9.645-1.723-.881-7.435-3.744-11.779-9.645C3.947 20.37 3.107 14.53 2.846 12.744l2.595-1.392V9.421l2.571-1.393V6.101C11.57 4.403 15.489 3.289 20 2.69c4.509.599 8.429 1.717 11.987 3.411V8.03l2.573 1.393v1.931l2.595 1.392z">
                </path>
                <path
                    d="M16.153 7.329l.12 15.697-.109.064c-1.661-4.201-2.653-9.441-2.966-14.699a20.571 20.571 0 00-2.569 1.383c.357 4.769 1.175 8.941 2.637 12.901l-.829.48C10.24 20.08 8.805 16.34 7.821 11.902a22.857 22.857 0 00-2.009 2.059c1.288 5.327 3.315 9.36 6.277 12.645l2.283-1.365a26.286 26.286 0 004.417 6.469V6.865a17.12 17.12 0 00-2.635.465zM30.853 15.421c.931-1.031 1.129-1.779 1.129-2.687 0-1.285-1.059-2.427-2.603-3.407-.931-.593-2.357-1.312-4.437-1.891a17.486 17.486 0 00-3.729-.573v24.848c5.221-2.688 11.432-10.056 11.464-13.805.009-1.145-.595-1.895-1.825-2.485m-7.071-5.587c1.287 0 5.447 1.315 5.447 2.976 0 .599-.528 1.456-2.173 2.321l-3.272 1.755zm3.243 13.781c-.736.847-1.939 2.141-3.243 3.147v-7.131s4.721-2.657 4.895-2.769c1.413.357 1.341 1.397 1.341 1.505-.001 1.309-1.339 3.336-2.995 5.249">
                </path>
            </svg>
            <div class="footer-copyright">
                TM &amp; © 2026 Warner Bros. Entertainment Inc. All rights
                reserved.
            </div>
        </div>
        <div class="basic_wraps" v-if="showLogin">
            <div class="form-box">
                <form class="form">
                    <a class="off-btn" @click.stop="showLogin = false">×</a>
                    <div class="cut_login">
                        <!-- <router-link class="cur" to="/login">{{ $t('login.signIn') }}
                            <div class="line"></div>
                        </router-link>
                        <router-link to="/register">{{ $t('login.signUp') }}
                            <div class="line"></div>
                        </router-link> -->
                        <div style="color: #fff;font-size: 28px;margin-bottom: 16px;">
                            {{ $t('login.signIn') }}
                        </div>
                        <div
                            style="color: #959BB8;font-size: 16px;margin-bottom: 24px;letter-spacing: 1px;text-indent: 1px;">
                            {{ $t('登录您的账户') }}
                        </div>
                    </div>
                    <div class="item" style="padding-left: 0px;margin-bottom: 24px;">
                        <!-- <span class="icon">
                            <img src="../images/login/tel.png" alt="" />
                        </span> -->
                        <a class="text-phone" @click.stop="countryShow = !countryShow">
                            {{ data.country }} <i class="iconfont icon-xiajiantou1" style="margin-left: 4px;"></i>
                        </a>
                        <input type="text" class="inp" v-model.trim="data.username"
                            :placeholder="$t('setpaypwd.pureNumber')" />
                        <div class="item_box" v-if="countryShow">
                            <div class="search-box">
                                <input type="text" v-model="searchCode" :placeholder="$t('搜索区号')"
                                    style="color: #232649 !important;" @input="inputFun"></input>
                            </div>
                            <a v-for="(item, index) in countrys" :key="index"
                                :class="{ 'active': item.code === data.country }" @click.stop="onSelect(item)">
                                {{ item.code }} {{ item.text }}
                            </a>
                            <div v-if="countrys.length === 0" style="padding: 10px;text-align: center;color: #666;">
                                {{ $t('item.noData') }}
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="icon" style="height: 20px;width: 20px;"><img src="../images/login/locks.png"
                                alt="" /></div>
                        <input :type="password" class="inp" v-model.trim="data.password"
                            :placeholder="$t('login.password')" />
                        <div class="eye_bi" @click="showPwd" :class="password == 'text' ? 'eye' : ''"></div>
                    </div>
                    <!-- <div class="item_reset_pwd">
                        <van-checkbox v-model="checked" icon-size="14px">{{ $t('login.remember') }}</van-checkbox>
                    </div> -->
                    <div class="flexs" style="margin-top: 20px;">
                        <van-checkbox v-model="checkeds" icon-size="14px" shape="square" checked-color="#3d96ff">
                            <span style="color: #959BB8;">{{ $t('wytx') }}</span>
                        </van-checkbox>
                        <router-link style="color: #3d96ff;margin-left: 5px;" to="/xys">
                            {{ $t('用户协议') }}
                        </router-link>
                    </div>
                </form>
                <div type="submit" class="basic_btn sbtn" :class="data.username == '' || data.password == '' ? 'no_touch' : ''
                    " @click="submit">
                    {{ $t('login.signInBtn') }}
                </div>
                <div class="bian-box">
                    <span class="bian"></span>
                    <span class="text">{{ $t('或') }}</span>
                    <span class="bian"></span>
                </div>
                <div class="text-box">
                    <span style="color:#959BB8;font-size: 14px;">
                        {{ $t('还没加入') }}
                    </span>
                    <a @click.stop="offLogin">
                        <span style="color:#5051D0;font-size: 14px;">{{ $t('register.signUpBtn') }}</span>
                        <i class="iconfont icon-youjiantou21" style="color:#5051D0;font-size: 12px;"></i>
                    </a>
                </div>
            </div>

        </div>

        <div class="basic_wraps" v-if="showRegister">
            <div class="form-box">
                <form class="form">
                    <a class="off-btn" @click.stop="showRegister = false">×</a>
                    <div class="cut_login">
                        <div style="color: #fff;font-size: 28px;margin-bottom: 16px;">
                            {{ $t('login.signUp') }}
                        </div>
                        <div
                            style="color: #959BB8;font-size: 16px;margin-bottom: 24px;letter-spacing: 1px;text-indent: 1px;">
                            {{ $t('创建您的账户') }}
                        </div>
                    </div>
                    <div class="item" style="margin-bottom: 12px;">
                        <span class="icon2">
                            <img src="../images/login/sj.png" alt="">
                        </span>
                        <a class="text-phone" @click.stop="countryShow = !countryShow">{{ data2.country }} <i class="iconfont icon-xiajiantou1" style="margin-left: 4px;"></i></a>
                        <input v-model.trim="data2.mobile" type="text" class="inp"
                            :placeholder="$t('setpaypwd.pureNumber')">
                        <div class="item_box" v-if="countryShow">
                            <div class="search-box">
                                <input type="text" v-model="searchCode" :placeholder="$t('搜索区号')"
                                    style="color: #232649 !important;" @input="inputFun"></input>
                            </div>
                            <a v-for="(item, index) in countrys" :key="index"
                                :class="{ 'active': item.code === data2.country }" @click.stop="onSelect(item)">
                                {{ item.code }} {{ item.text }}
                            </a>
                            <div v-if="countrys.length === 0" style="padding: 10px;text-align: center;color: #666;">
                                {{ $t('item.noData') }}
                            </div>
                        </div>
                    </div>
                    <div class="item" style="margin-bottom: 12px;">
                        <span class="icon2">
                            <img src="../images/login/emails.png" alt="">
                        </span>
                        <input v-model="data2.email" type="text" class="inp" :placeholder="$t('请输入邮箱')">
                    </div>
                    <div class="item" style="margin-bottom: 12px;">
                        <span class="icon2">
                            <img src="../images/login/locks.png" alt="">
                        </span>
                        <input v-model.trim="data2.password" :type="password" class="inp"
                            :placeholder="$t('register.password')">
                        <div class="eye_bi" :class="password == 'text' ? 'eye' : ''" @click="showPwd" />
                    </div>
                    <div class="item" style="margin-bottom: 12px;">
                        <span class="icon2">
                            <img src="../images/login/locks.png" alt="">
                        </span>
                        <input v-model.trim="data2.spassword" :type="password" class="inp"
                            :placeholder="$t('register.passwordEmpty')">
                        <div class="eye_bi" :class="password == 'text' ? 'eye' : ''" @click="showPwd" />
                    </div>
                    <div class="item" style="margin-bottom: 12px;">
                        <span class="icon2">
                            <img src="../images/login/aq.png" class="people" alt="">
                        </span>
                        <input v-model.trim="data2.invite_code" type="text" class="inp"
                            :placeholder="$t('invite_code')">
                    </div>

                </form>
                <div class="basic_btn sbtn" :class="data2.mobile == '' ||
                    data2.password == '' ? 'no_touch' : ''" @click="submit2">
                    {{ $t('register.signUpBtn') }}
                </div>
                <div class="flexs" style="margin-top: 20px;">
                    <van-checkbox v-model="checkeds" icon-size="14px" shape="square" checked-color="#3d96ff">
                        <span style="color: #959BB8;">{{ $t('wytx') }}</span>
                    </van-checkbox>
                    <router-link style="color: #3d96ff;margin-left: 5px;" to="/xys">
                        {{ $t('用户协议') }}
                    </router-link>
                </div>
                <div class="bian-box">
                    <span class="bian"></span>
                    <span class="text">{{ $t('或') }}</span>
                    <span class="bian"></span>
                </div>
                <div class="text-box">
                    <span style="color:#959BB8;font-size: 14px;">
                        {{ $t('已有账号') }}
                    </span>
                    <a @click.stop="offRegister">
                        <span style="color:#5051D0;font-size: 14px;">{{ $t('login.signInBtn') }}</span>
                        <i class="iconfont icon-youjiantou21" style="color:#5051D0;font-size: 12px;"></i>
                    </a>
                </div>
            </div>

        </div>

        <div class="basic_wrap2" style="overflow: hidden;" v-if="menuShow" >
            <div class="red_top_bg"
                style="display: flex;height: fit-content; padding: 8px 20px;justify-content: space-between;">
                <div class="logos">
                    <svg fill="#fff">
                        <path
                            d="M36.877 9.965V8.042l-2.573-1.393V4.638l-1.319-.627C29.239 2.222 25.093 1.028 20.313.392l-.312-.043-.312.043c-4.781.635-8.927 1.829-12.675 3.617l-1.319.628v2.011L3.123 8.041v1.925L.328 11.464l.221 1.597C1.29 18.42 3.242 23.27 6.354 27.48c3.144 4.253 7.387 7.733 12.613 10.344l1.035.517 1.035-.517c5.225-2.611 9.469-6.091 12.613-10.344 3.111-4.208 5.063-9.059 5.805-14.419l.221-1.597zm.273 2.779c-.261 1.787-1.101 7.627-5.373 13.359-4.344 5.901-10.056 8.765-11.779 9.645-1.723-.881-7.435-3.744-11.779-9.645C3.947 20.37 3.107 14.53 2.846 12.744l2.595-1.392V9.421l2.571-1.393V6.101C11.57 4.403 15.489 3.289 20 2.69c4.509.599 8.429 1.717 11.987 3.411V8.03l2.573 1.393v1.931l2.595 1.392z">
                        </path>
                        <path
                            d="M16.153 7.329l.12 15.697-.109.064c-1.661-4.201-2.653-9.441-2.966-14.699a20.571 20.571 0 00-2.569 1.383c.357 4.769 1.175 8.941 2.637 12.901l-.829.48C10.24 20.08 8.805 16.34 7.821 11.902a22.857 22.857 0 00-2.009 2.059c1.288 5.327 3.315 9.36 6.277 12.645l2.283-1.365a26.286 26.286 0 004.417 6.469V6.865a17.12 17.12 0 00-2.635.465zM30.853 15.421c.931-1.031 1.129-1.779 1.129-2.687 0-1.285-1.059-2.427-2.603-3.407-.931-.593-2.357-1.312-4.437-1.891a17.486 17.486 0 00-3.729-.573v24.848c5.221-2.688 11.432-10.056 11.464-13.805.009-1.145-.595-1.895-1.825-2.485m-7.071-5.587c1.287 0 5.447 1.315 5.447 2.976 0 .599-.528 1.456-2.173 2.321l-3.272 1.755zm3.243 13.781c-.736.847-1.939 2.141-3.243 3.147v-7.131s4.721-2.657 4.895-2.769c1.413.357 1.341 1.397 1.341 1.505-.001 1.309-1.339 3.336-2.995 5.249">
                        </path>
                    </svg>
                </div>
                <div class="img-x" @click.stop="menuShow = false">
                    ×
                </div>
            </div>
            <div style="width: 100%;height: fit-content;" @click.stop>
                <van-cell size="large" @click="showLoginFun">
                    <template #title>
                        <div style="display: flex;align-items: center;">
                            <img style="display: block; width: 24px; height:24px;margin-right: 20px;"
                                src="../images/login/1.png" alt="">
                            <div style="color: #fff;">{{ $t('在线登录') }}</div>
                        </div>
                    </template>
                </van-cell>
                <van-cell size="large" @click="showRegisterFun">
                    <template #title>
                        <div style="display: flex;align-items: center;">
                            <img style="display: block; width: 24px; height:24px;margin-right: 20px;"
                                src="../images/login/2.png" alt="">
                            <div style="color: #fff;">{{ $t('register.signUpBtn') }}</div>
                        </div>
                    </template>
                </van-cell>
                <van-cell size="large" @click.stop="toPath('/language')">
                    <template #title>
                        <div style="display: flex;align-items: center;">
                            <img style="display: block; width: 24px; height:24px;margin-right: 20px;"
                                src="../images/login/3.png" alt="">
                            <div style="color: #fff;">{{ $t('safe.language') }}</div>
                        </div>
                    </template>
                </van-cell>
                <van-cell @click="toKefuLink" size="large">
                    <template #title>
                        <div style="display: flex;align-items: center;">
                            <img style="display: block; width: 24px; height:24px;margin-right: 20px;"
                                src="../images/login/4.png" alt="">
                            <div style="color: #fff;">{{ $t('user.onlineService') }}</div>
                        </div>
                    </template>
                </van-cell>
                <van-cell size="large" @click.stop="toPath('/about/13')">
                    <template #title>
                        <div style="display: flex;align-items: center;">
                            <img style="display: block; width: 24px; height:24px;margin-right: 20px;"
                                src="../images/login/5.png" alt="">
                            <div style="color: #fff;">{{ $t('index.secret') }}</div>
                        </div>
                    </template>
                </van-cell>
                <van-cell size="large" @click.stop="toPath('/about/12')">
                    <template #title>
                        <div style="display: flex;align-items: center;">
                            <img style="display: block; width: 24px; height:24px;margin-right: 20px;"
                                src="../images/login/6.png" alt="">
                            <div style="color: #fff;">{{ $t('index.agreement') }}</div>
                        </div>
                    </template>
                </van-cell>
                <van-cell size="large" @click.stop="toPath('/about/11')">
                    <template #title>
                        <div style="display: flex;align-items: center;">
                            <img style="display: block; width: 24px; height:24px;margin-right: 20px;"
                                src="../images/login/7.png" alt="">
                            <div style="color: #fff;">{{ $t('index.aboutUs') }}</div>
                        </div>
                    </template>
                </van-cell>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import Fetch from "../../utils/fetch"
import { CountDown, Checkbox, Toast } from 'vant'
Vue.use(Checkbox)

export default {
    name: "login",
    data() {
        return {
            showRegister: false,
            showLogin: false,
            accountData: [
                { username: "@WarnerBros" },
                { username: "@WarnerBrosComedy" },
                { username: "@WarnerBrosHorror" },
                { username: "@WarnerBrosEpics" },
            ],
            filmList: [],
            newsList: [],
            countryShow: false,
            countrys: [],
            countrys2: [],
            lang: this.$i18n.locale,
            password: "password",
            show_kefu: false,
            msg_show: true,
            checked: true,
            checkeds: false,
            data: {
                username: "",
                password: "",
                country: localStorage.getItem('countryCode') || "+1"
            },
            data2: {
                password: "",
                spassword: "",
                email: "",
                mobile: "",
                code: "",
                invite_code: "",
                agent: 10000,
                country: localStorage.getItem('countryCode') || "+1"
            },
            logo: localStorage.getItem('logo') || '',
            kefu_link: '',
            searchCode: '',
            menuShow: false,
            menuList: [
                { label: this.$t('index.recharge'), path: '/invest' },
                { label: this.$t('我要提现'), path: '/cash' },
                { label: this.$t('index.secret'), path: '/about/13' },
                { label: this.$t('index.agreement'), path: '/about/12' },
                { label: this.$t('index.aboutUs'), path: '/about/11' },
            ]
        };
    },
    created() {
        this.data.username = localStorage.getItem('login_username');
        this.data.password = localStorage.getItem('login_password');
        this.$parent.footer("user", false);
        Fetch("/index/webconfig").then((r) => {
            this.logo = r.data.logo
            this.kefu_link = r.data.kefu_link
            localStorage.setItem('logo', r.data.logo)
        });
        Fetch("/loan/countrys").then((r) => {
            this.countrys = r.data.map(x => {
                return { text: x.name, code: x.code }
            })
            this.countrys2 = r.data.map(x => {
                return { text: x.name, code: x.code }
            })
        });
        Fetch('/loan/item_index').then(r => {

            this.newsList = r.data.news
            this.filmList = r.data.popular
            console.log('r---------->', this.newsList)
        })
    },
    mounted() {
        var that = this;
        document.body.addEventListener(
            "scroll",
            function () {
                if (!that.show_kefu) {
                    return;
                }
                that.show_kefu = false;
            },
            false
        );
        document.addEventListener(
            "click",
            function (ev) {
                if (ev.target.className != "kefu_img") {
                    that.show_kefu = false;
                }
            },
            false
        );
    },
    methods: {
        resetFun() {
            location.reload()
        },
        toPath(url) {
            this.$router.push(url)
        },
        toUrl(url) {
            window.open(url,'blank')
        },
        showLoginFun() {
            this.menuShow = false;
            this.countryShow = false;
            this.showLogin = true;
        },
        showRegisterFun() {
            this.menuShow = false;
            this.countryShow = false;
            this.showRegister = true;
        },
        offRegister() {
            this.showRegister = false;
            this.countryShow = false;
            this.showLogin = true;
        },
        offLogin() {
            this.showLogin = false;
            this.countryShow = false;
            this.showRegister = true;
        },
        inputFun() {
            // 如果输入框为空，恢复原始数据
            if (!this.searchCode) {
                this.countrys = [...this.countrys2];
                return;
            }

            // 筛选逻辑：精准匹配区号数字
            const searchValue = this.searchCode;
            this.countrys = this.countrys2.filter(item => {
                // 去除code中的+号，只保留数字进行匹配
                const codeNumber = item.code.replace('+', '');
                // 精准完全相等匹配
                return codeNumber === searchValue;
            });
        },
        toKefuLink() {
            window.location.href = this.kefu_link
        },
        onSelect(action) {
            this.data.country = action.code
            this.countryShow = false
        },
        kefu_to() {
            if (this.show_kefu) {
                this.$router.push("/kefu");
            }
            this.show_kefu = !this.show_kefu;
        },
        showPwd() {
            if (this.password == "password") {
                this.password = "text";
            } else {
                this.password = "password";
            }
        },
        submit() {
            let that = this;
            if (!this.checkeds) {
                this.$toast(this.$t('qyexy'));
                return;
            }
            if (!this.data.username) {
                this.$toast(this.$t('setpaypwd.pureNumber'));
                return;
            }

            if (!this.data.password) {
                this.$toast(this.$t('login.passwordEmpty'));
                return;
            }

            // var regex = /^[A-Za-z0-9]{1,20}$/;
            // if (!regex.test(this.data.username)) {
            //     this.$toast(this.$t('login.phoneError'));
            //     return;
            // }

            // if (this.checked) {
            //     localStorage.setItem('login_username', this.data.username);
            //     localStorage.setItem('login_password', this.data.password);
            // }

            // if (!this.checked) {
            //     localStorage.removeItem('login_username');
            //     localStorage.removeItem('login_password');
            // }

            Fetch("/index/login", {
                username: this.data.username,
                password: this.data.password,
                country: this.data.country
            }).then((res) => {
                // console.log(res,'res')
                if (res.data && res.data.token) {
                    localStorage.setItem('token', res.data.token);
                    localStorage.setItem('countryCode', that.data.country)
                    this.$toast({
                        background: "#07c160",
                        message: this.$t('login.signInSuccess'),
                    });
                    setTimeout(() => {
                        this.$router.push('/index')
                    }, 500);
                } else {
                    Toast(res.msg)
                }
            })
        },

        submit2() {
            if (!this.checkeds) {
                this.$toast(this.$t('qyexy'));
                return;
            }
            if (!this.data2.mobile) {
                this.$toast(this.$t('setpaypwd.pureNumber'));
                return false;
            }
            if (!this.data2.password) {
                this.$toast(this.$t('register.passwordEmpty'));
                return false;
            }
            if (!this.data2.spassword) {
                this.$toast(this.$t('register.passwordAgainEmpty'));
                return false;
            }
            if (!this.data2.invite_code) {
                this.$toast(this.$t('invite_code'));
                return false;
            }

            // if (!this.data2.code && this.config.sms_verify) {
            //     this.$toast(this.$t('register.codeEmpty'));
            //     return false;
            // }
            if (this.data2.password != this.data2.spassword) {
                this.$toast(this.$t('register.passwordError'));
                return false;
            }

            Fetch("/index/register", {
                ...this.data2,
            }).then((res) => {
                if (res.code == 1) {
                    if (res.data.token) {
                        localStorage.setItem('token', res.data.token);
                    }
                    this.$toast(this.$t('register.signUpSuccess'));
                    setTimeout(() => {
                        this.$router.replace("/");
                    }, 1000)
                    return
                }
                this.$toast(res.msg);
            });
        },
    },
};
</script>

<style lang="less" scoped>
.basic_wrap {
    background: rgba(37, 43, 184, 0.9) url('../../assets/images/bg_mobile.png') no-repeat center top / cover;
    position: relative;

    .bgImg {
        z-index: 0;
    }
}

/* 顶部导航 */
.page-header {
    background: #000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 20px;
    position: relative;
    position: sticky;
    top: 0px;
    z-index: 999;
}

.header-logo svg {
    width: 42px;
    height: 42px;
}

.menu-btn {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.menu-btn span {
    width: 24px;
    height: 3px;
    background: #fff;
    border-radius: 2px;
}

/* 主体内容居中 */
.content-wrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 20px;
}

/* 中心WB大logo */
.main-wb-logo {
    width: 230px;
    margin-bottom: 24px;
}

.main-wb-logo img {
    display: block;
    width: 100%;
}

.account-list {
    display: flex;
    flex-direction: column;
    gap: 52px;
    text-align: center;
}

.account-item .follow-text {
    color: #c6c8e6;
    font-size: 18px;
    margin: 0 0 6px;
    font-weight: 300;
}

.account-item .username {
    color: #ffffff;
    font-size: 18px;
    margin: 10px 0 20px;
}

.social-icons {
    display: flex;
    gap: 8px;
    justify-content: center;

    .icon {
        width: 22px;
        height: 22px;
    }

    .icons {
        width: 22px;
        height: 22px;
        background: #ffffff;
        border-radius: 50%;
        padding: 5px;

        .icon {
            width: 12px;
            height: 12px;
        }
    }
}



/* 立即登录按钮 */
.login-btn {
    margin: 60px 0 40px;
    background: transparent;
    border: 4px solid #0066ff;
    color: #ffd000;
    font-size: 16px;
    font-weight: bold;
    padding: 12px 30px;
    border-radius: 999px;
}

/* 分割线 */
.divider-line {
    width: 100%;
    height: 2px;
    border-radius: 50%;
    background: #0066ff;
    box-shadow: 0px 0px 10px #0066ff;
    margin-bottom: 40px;
}

/* 影视区域 */
.movie-section {
    width: 100%;
}

.section-title {
    color: #fff;
    font-size: 18px;
    margin: 0 0 30px;
}

.movie-scroll-wrap {
    width: 100%;
    // overflow-x: auto;
    /* 隐藏滚动条（可选） */
    // scrollbar-width: none;
    display: flex;
    justify-content: space-between;
}

.movie-scroll-wrap::-webkit-scrollbar {
    display: none;
}

.movie-list {
    width: 100%;
    display: flex;
    height: fit-content;
    justify-content: space-between;
}

.movie-item {
    width: calc(100% / 3 - 10px);
    flex-shrink: 0;
    text-align: center;
    margin-right: 12px;

}

.movie-item:last-child {
    margin-right: 0px;
}

.poster {
    width: 100%;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 16px;
}

.poster img {
    width: 100%;
    height: 75px;
    display: block;
    object-fit: cover;
}

.film-name {
    width: 100%;
    height: fit-content;
    color: #e0e8ff;
    font-size: 14px;
    line-height: 16px;
    margin: 0;
    word-break: break-all;
    word-break: keep-all;
    overflow: hidden;
}

.gfNxcW {
    width: 100%;
    display: flex;
    flex-direction: column;
    height: auto;
    width: 100%;
    padding: 10px 20px;
    background: #000;
    padding-top: 20px;

    svg {
        fill: #fff;
    }
}

.kHvagc {
    display: flex;
    width: 100%;
    justify-content: space-around;
}

.ezeceZ {
    font-size: 16px;
    width: 100%;
    text-align: center;
    color: rgb(204, 203, 203);
}

.kHvagc {
    justify-content: space-between;
    width: 100%;
    margin:24px 0px 0px;
    padding: 0px 10px 10px 10px;
}

.kHvagc a {
    position: relative;
    width: 20px;
}

.basic_wraps {
    width: 100%;
    height: 100%;
    max-width: 750px;
    min-height: 100dvh;
    position: relative;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    background: rgba(0, 0, 0, 0.85);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;

    .form-box {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 88%;
        height: fit-content;
        padding: 35px 15px;
        background: rgba(31, 39, 81, 0.9);
        box-shadow: 0px 0px 4px #7d7aa1;
        border-radius: 10px;

        .off-btn {
            display: block;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            color: #fff;
            font-size: 34px;
            position: absolute;
            right: 15px;
            top: 20px;
            z-index: 1;
        }
    }

    .basic_wraps .form {
        margin: 5em auto;
        width: 100%;
        height: 312px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 4px 9px 2px rgba(160, 160, 160, 0.15);
        border-radius: 13px;
        padding: 31px 24px 0 24px;
    }

    .big_tit {
        color: #fff !important;
    }

    .cut_login {
        width: 100%;
        line-height: 25px;
        display: flex;
        flex-direction: column;
        font-size: 18px;
        margin: 0 auto;

        a {
            width: 50%;
            padding-bottom: 10px;
            color: #ceced0;
            position: relative;

            .line {
                width: 100%;
                height: 1px;
                position: absolute;
                left: 0;
                bottom: 0;
                background-color: #f2f2f2;
            }
        }

        a.cur {
            color: #000;

            .line {
                height: 2px;
                background-image: linear-gradient(to right, #000, #000);
            }
        }
    }

    .mt {
        margin-top: 20px;
    }

    .item {
        height: 52px;
        background: #333769;
        box-shadow: 0px 0px 4px #7d7aa1;
        font-size: 14px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        padding: 0px 10px;

        .item_box {
            width: 100%;
            height: fit-content;
            min-height: 108px;
            max-height: 320px;
            overflow-y: scroll;
            position: absolute;
            left: 0px;
            top: 72px;
            background: #fff;
            box-shadow: 0 0 3px #999;
            border-radius: 10px;
            padding: 10px 10px 0px 10px;
            z-index: 10;

            .search-box {
                height: 40px;
                width: 100%;
                background: #eee;
                border-radius: 8px;
                margin-bottom: 10px;
                padding: 0 10px;
                box-sizing: border-box;

                input {
                    width: 100%;
                    height: 100%;
                    font-size: 14px;
                }
            }

            a {
                display: block;
                width: 100%;
                height: 38px;
                border-bottom: 1px solid #eee;
                line-height: 38px;
                padding: 0 8px;
            }

            .active {
                background: #eee;
            }
        }

        .icon {
            width: 24px;
            height: 24px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .icon2 {
            width: 24px;
            height: 24px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        input {
            height: 20px;
            margin-left: 10px;
            flex: 1;
            margin-bottom: 0px;
            color: #ffffff;
        }
    }

    .flexs {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 10px;
        font-size: 14px;

        .van-checkbox {
            margin-top: 0px;
            margin-left: 5px;
        }
    }

    .item_reset_pwd {
        font-size: 14px;
        color: #3d96ff;
        text-align: right;
        margin-top: 10px;
        line-height: 20px;
    }

    .van-checkbox {
        margin-top: 20px;
    }

    .reset_pwd {
        color: #3d96ff;
        margin-top: -20px;
        display: block;
    }

    .basic_btn {
        width: 100%;
        margin: 20px auto 0 auto;
        background: #4E5BFF;
        height: 54px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .text-phone {
        width: fit-content;
        height: 24px;
        display: flex;
        align-items: center;
        padding: 0px 10px;
        border-right: 1px solid #515380;
        color: #ffffff;
    }

    .bian-box {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        padding: 20px 0px;

        .text {
            margin: 0 15px;
            font-size: 16px;
            color: #959BB8;
        }

        .bian {
            display: block;
            width: 40%;
            height: 1px;
            background: #959BB8;
        }
    }

    form {
        width: 96%;
    }

    // background: url('~@/assets/images/bg1.jpg') no-repeat center center / cover;
}

.basic_wrap2 {
    width: 100%;
    max-width: 750px;
    height: 100%;
    background: #101012;
    position: relative;
    position: fixed;
    left: 50%;
    transform: translate(-50%, -50%);
    top: 50%;
    z-index: 999;
    padding: 0px;

    .red_top_bg {
        width: 100%;
        background: #000;
        height: 52px;

        .logos {
            width: fit-content;
            height: 30px;

            img {
                width: auto;
                height: 100%;
                display: block;
            }
        }

        .img-x {
            display: block;
            font-size: 34px;
            color: #fff;
        }
    }

    .van-cell {
        background: #101012;
        padding: 20px;
    }

    .van-cell--large {
        padding: 22px 20px;
    }
}

.sc-bRBYWo {
    background: #101012;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: fit-content;
    padding-bottom: 20px;
    .footer-copyright {
        color: #ffffff;
        font-size: 10px;
        margin-left: 10px;
    }
}

::v-deep .van-cell::after {
    border-bottom: 0.5px solid #303030;
}
::v-deep .van-icon:before {
    display: none;
}
</style>
